@if (brand == 'prixtel') {
  <app-vitrine-menu></app-vitrine-menu>
}
@if (brand == 'coriolis') {
  <app-vitrine-menu-coriolis></app-vitrine-menu-coriolis>
}

<div [id]="'wrapper-' + brand" class="wpx_wrap">
  @if (brand == 'lacarte') {
    <a href="{{ vitrineUrl }}" class="logo"></a>
  }
  <app-breadcrumb [breadcrumb]="breadcrumbDetails" [brand]="brand"></app-breadcrumb>
  @if (brand !== 'lacarte') {
    <h1>Identification@if (brand == 'prixtel') {
      <span></span>
    }</h1>
  }
</div>

<div [id]="'login-form-' + brand" class="form_container">
  <div class="wpx_wrap">
    @if (brand !== 'lacarte') {
      <h2>Connectez-vous pour <span>accéder à votre Espace client</span></h2>
    }
    <div class="card card-signin my-5">
      <div class="card-body text-center">
        @if (brand == 'lacarte') {
          <h1>Identification</h1>
        }
        @if (brand == 'lacarte') {
          <h2>Connectez-vous pour <span>accéder à votre Espace client</span></h2>
        }
        @if (!displayConfirmationCode) {
          <p class="login-message">Si vous rencontrez des difficultés pour vous connecter, essayez de vider votre cache et de supprimer vos cookies. Si le problème persiste, veuillez vous connecter en utilisant une fenêtre de navigation privée.</p>
        }
        @if (captchaKey && !displayConfirmationCode) {
          <form class="form" [formGroup]="loginForm">
            <ul>
              <li>
                <label for="inputLogin" class="bold-label-text">Votre numéro de téléphone ou e-mail*</label>
                <div class="form-group">
                  <input type="text" id="inputLogin" class="form-control" placeholder="Entrez votre numéro de téléphone ou e-mail" formControlName="login">
                  @if (loginFormSubmitted && loginForm.controls.login.errors) {
                    <p class="error-message">{{ getError('login') }}</p>
                  }
                  @if (errorMessageLogin) {
                    <p class="error-message">{{ errorMessageLogin }}</p>
                  }
                  <a (click)="goTo('nouvel-email')" class="cta_level_3 alt1">Changer l'email de mon compte<span></span></a>
                </div>
              </li>
              <li>
                <label for="inputPassword" class="bold-label-text password">Votre mot de passe*</label>
                <div class="form-group wpx_passWrap">
                  <a href="#" id="togglePass" (click)="togglePasswordService.toggle($event)">Voir</a>
                  <input type="password" id="inputPassword" class="form-control" placeholder="Entrez votre mot de passe" formControlName="password">
                  @if (loginFormSubmitted && loginForm.controls.password.errors) {
                    <p class="error-message">{{ getError('password') }}</p>
                  }
                  <a (click)="goTo('oubli-mdp')" class="cta_level_3 alt2">Mot de passe oublié ?<span></span></a>
                </div>
              </li>
            </ul>
            @if (brand === 'coriolis') {
              <div class="form-group former-customer-pages">
                <p><a href="https://espace-entreprises.coriolis.fr/authentification/connecter-login.aspx">Ancien Espace Client Pro</a></p>
              </div>
            }
            <re-captcha #captcha="reCaptcha" (resolved)="resolved($event)" size="invisible" [siteKey]="captchaKey" (error)="errored(captcha)" errorMode="handled"></re-captcha>
            <button type="submit" class="cta_btn level_2" (click)="onLoginClick(captcha)">Se connecter<span></span></button>
            @if (brand === 'lacarte') {
              <div class="form-group first-connexion">
                <a (click)="goTo('premiere-connexion')" class="cta_level_3 alt2">Première connexion<span></span></a>
              </div>
            }
          </form>
        }
        @if (displayConfirmationCode) {
          <p class="login-message">
            Pour accéder à votre compte {{ brand == 'lacarte' ? 'SFR Discover' : brand | titlecase }},
            la saisie d'un code de sécurité est nécessaire.<br />
            @if (sendMfaCodeBy !== 'sms') {
              <strong>Ce code a été envoyé à l'adresse e-mail associée à votre compte.</strong>
            }
            @if (sendMfaCodeBy == 'sms') {
              <strong>Ce code a été envoyé par SMS.</strong>
            }
          </p>
        }
        @if (displayConfirmationCode) {
          <ul id="confirmation-code-{{ brand }}">
            <li>
              <label for="code" class="bold-label-text">Votre code de confirmation*</label>
              <div class="form-group">
                <input type="text" id="code" class="form-control" placeholder="Entrez code de confirmation" [(ngModel)]="confirmationCode">
                @if (errorMessageConfirmationCode) {
                  <p class="error-message">{{ errorMessageConfirmationCode }}</p>
                }
              </div>
              <p class="mt-2">
                <strong>
                  Ce code ne doit jamais être communiqué à personne, sous aucun prétexte, ni être saisi ailleurs que sur cette page.
                  <br/>
                  Nous ne vous demanderons jamais de code, ni par téléphone ni par SMS.
                </strong>
              </p>
              @if (sendMfaCodeBy !== 'sms') {
                <p>
                  Si vous n'avez plus accès à cette adresse e-mail, cliquez sur :<br/>
                  <a (click)="goTo('nouvel-email')" class="cta_level_3 alt1">Changer l'email de mon compte<span></span></a>
                  <br/>
                  <span class="bold-text">Vous n’avez pas reçu ce code ?</span> Vérifiez dans le dossier “Courrier indésirable” ou “Spam” de votre messagerie.
                </p>
              }
              <div class="bloc_cta">
                <button class="cta_cancel" (click)="cancel()">Annuler<span></span></button>
                <button type="submit" class="cta_btn level_2" (click)="validateCode()">Valider<span></span></button>
              </div>
            </li>
          </ul>
        }
      </div>
    </div>
  </div>
</div>

@if (brand == 'prixtel') {
  <app-vitrine-footer></app-vitrine-footer>
}
@if (brand == 'coriolis') {
  <app-vitrine-footer-coriolis></app-vitrine-footer-coriolis>
}

